<template>
  <transition name="fade">
    <div
      v-if="isDisplayed && !appEmbedded"
      class="fullscreen-editor"
      @click="wrapperClicked"
    >
      <div class="fullscreen-editor__wrapper">
        <div class="fullscreen-editor__wrapper__label-wrapper">
          <EditableLabel
            ref="editor"
            v-model="editorValue"
            class="f-w"
            :is-fs-editor="true"
            v-bind="editorOptions"
            :prevent-click-outside="isAnimating"
            @focus="onFocus"
          />
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div v-show="editorOptions.hint != ''" class="field-hint" v-html="editorOptions.hint" />
        </div>
        <div class="fullscreen-editor__wrapper__button-wrapper h-v-centerer">
          <button class="action-btn" @click="onEnd">
            {{ $t('message.OK') }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
/**
 * Component used on small mobile devices inorder to edit fields more easily.
 * It displays the classic EditableLabel component according to the options provided by the caller.
 * Caller usually is another EditableLabel component.
 */

// Components
import EditableLabel from '@/components/editable-label.vue';
// Event manager
import { ShizenGlobalEvent, globalEventDispatcher } from '@/utils/event-dispatcher/global';

export default {

  name: 'FullscreenEditor',

  components: {
    EditableLabel,
  },

  data() {
    return {
      editorOptions: {},
      editorValue: '',
      componentId: null,
      isAnimating: false,
      isDisplayed: false,
    };
  },

  created() {
    globalEventDispatcher.register(ShizenGlobalEvent.FS_EDITOR_SHOW, this.setupEditor);
    globalEventDispatcher.register(ShizenGlobalEvent.FS_EDITOR_DO_FOCUS, () => {
      if (this.$refs.editor) {
        this.$refs.editor.doFocus();
      }
    });
  },

  beforeDestroy() {
    globalEventDispatcher.unregister(ShizenGlobalEvent.FS_EDITOR_SHOW, this.setupEditor);
  },

  methods: {
    /** Setup the editor's options and show it */
    setupEditor(options) {
      this.componentId = options.editorOptions.uuid;
      this.editorValue = options.editorOptions.value;
      this.editorOptions = options.editorOptions._props;
      this.isDisplayed = true;
      this.$nextTick(() => {
        this.$refs.editor.edit();
      });
    },
    onFocus() {
      globalEventDispatcher.dispatch(`${ShizenGlobalEvent.FS_EDITOR_START_EDIT}.${this.componentId}`);
    },
    onEnd() {
      this.isDisplayed = false;
      globalEventDispatcher.dispatch(`${ShizenGlobalEvent.FS_EDITOR_HIDE}.${this.componentId}`, {
        value: this.editorValue,
      });
    },

    wrapperClicked(e) {
      if (this.isAnimating) {
        this.$refs.editor.doFocus();
        e.preventDefault();
        e.stopPropagation();
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.fullscreen-editor {
  position: fixed;
  width: 100%;
  height: 100%;
  background: #ffffff;
  z-index: 10020;
  top: 0px;
  left: 0px;

  &__wrapper {
    width: 100%;
    background: #ffffff;
    text-align: center;
    box-shadow: 0px 0px 5px #585858;
    display: flex;
    flex-flow: column;
    height: 100%;
    padding: 1.5em;
    box-sizing: border-box;

    &__label-wrapper {
      width: 100%;
      box-sizing: border-box;
      text-align: left;
      padding: 1.5em 0;
      flex: 1;
      overflow: auto;
    }

    &__button-wrapper {
      flex: 0 0 auto;
    }
  }
}
</style>
